import { render, staticRenderFns } from "./ModattaFooter.vue?vue&type=template&id=ef1eb404"
import script from "./ModattaFooter.vue?vue&type=script&lang=js"
export * from "./ModattaFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports